import { useRequiredContext } from "~/tools/use-required-context";

import { ExplorationDrawerStateContext } from "./_exploration-drawer-state-context";
import type { ExplorationDrawerState } from "./ExplorationDrawerState";

export const useExplorationDrawerState = (): ExplorationDrawerState => {
	const { state } = useRequiredContext(ExplorationDrawerStateContext, {
		providerName: "ExplorationDrawerStateProvider",
	});

	return state;
};
